import React, { useState, useRef, useEffect } from "react";
import { Toast } from "../../Component/Toast";
import { URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import RawWebSocket from "../../Websocker/RawWebSocket";

const DOUBLE_FALLBACK_MAX = 250;

const DoubleDigitScreen = ({
  doubleData,
  doublePrice,
  lotName,
  lotTime,
  slotId,
  userId,
}) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [rows, setRows] = useState(
    doubleData.map(() => ({
      digit1: "",
      digit2: "",
      amount: "1",
      win_price: "",
    })),
  );

  const digit1Refs = useRef([]);
  const digit2Refs = useRef([]);
  const amountRefs = useRef([]);

  // Use API max quantity; fall back to hardcoded if 0 or missing
  const maxQty =
    doublePrice?.maximum_quantity > 0
      ? doublePrice.maximum_quantity
      : DOUBLE_FALLBACK_MAX;

  const increaseAmount = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const current = parseInt(newRows[index].amount || "0", 10);
      const nextVal = current + 1;
      newRows[index] = {
        ...newRows[index],
        amount: nextVal > maxQty ? String(maxQty) : String(nextVal),
      };
      return newRows;
    });
  };

  const decreaseAmount = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const current = parseInt(newRows[index].amount || "0", 10);
      const nextVal = current > 0 ? current - 1 : 0;
      newRows[index] = {
        ...newRows[index],
        amount: String(nextVal),
      };
      return newRows;
    });
  };

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const handler = () => {
      setIsOpen(viewport.height < window.innerHeight);
    };
    viewport.addEventListener("resize", handler);
    return () => viewport.removeEventListener("resize", handler);
  }, []);

  const handleAdd = async (index) => {
    const row = rows[index];
    if (row.digit1 === "" || row.digit2 === "") {
      Toast("Please enter both digits");
      return;
    }
    if (parseInt(row.amount || "0", 10) <= 0) {
      Toast("Please enter a valid amount");
      return;
    }

    const value = `${row.digit1}${row.digit2}`;

    const addedValue = {
      lot_details:
        `${doublePrice?.fee_price_name} ${doubleData[index].alpha}${doubleData[index].alpha2} ${lotName === "Kerala 3 PM" ? "KERALA" : "DEAR"} ${lotTime}`.toUpperCase(),
      ticket_amount: doublePrice?.digit_fee * parseInt(row.amount || "0", 10),
      price: doublePrice?.digit_fee,

      my_number: value,
      count: parseInt(row.amount || "0", 10),
      client_id: userId,
      fee_price_id: doublePrice?.fee_price_id,
      game_slot_id: slotId || null,
      type: doublePrice?.type,
      digit: `${doubleData[index].alpha}${doubleData[index].alpha2}`,
      name: `${doublePrice?.fee_price_name} ${doubleData[index].alpha}${doubleData[index].alpha2} ${lotName === "Kerala 3 PM" ? "KERALA" : "DEAR"} ${lotTime}`.toUpperCase(),
    };

    console.log("✅ Added Value:", addedValue);

    let payload = {
      user_id: userId,
      cart_item: [addedValue],
    };
    console.log("add via socket:", payload);
    RawWebSocket.emit("cart_add", payload);

    setRows((prev) => {
      const copy = [...prev];
      copy[index] = { digit1: "", digit2: "", amount: "1" };
      return copy;
    });
    if (isKeyboardOpen && isOpen) {
      digit1Refs.current[index]?.focus();
    }
  };

  const handleRandom = () => {
    setIsKeyboardOpen(false);
    setRows((prev) =>
      prev.map((row) => ({
        ...row,
        digit1: String(Math.floor(Math.random() * 10)),
        digit2: String(Math.floor(Math.random() * 10)),
      })),
    );
  };

  return (
    <div className="sd-container">
      <div className="sd-card">
        <div className="sd-card-header">
          <div>
            <div className="sd-row">
              <div className="sd-card-title">{`${doublePrice?.fee_price_name?.replace(/[0-9]/g, "") || ""}${doublePrice?.fee_price_name ? " Win" : ""}`}</div>
              <div className="sd-price">{`₹${doublePrice?.price || ""}`}</div>
            </div>
            <div className="sd-row">
              <div className="sd-small">Buy price</div>
              <div className="sd-price">{`₹${doublePrice?.digit_fee || ""}`}</div>
            </div>
          </div>
          <div className="sd-random" onClick={handleRandom}>
            Random
          </div>
        </div>

        {doubleData.map((label, index) => (
          <div className="sd-input-row" key={index}>
            <div className="sd-left">
              <div className="sd-ab">{label.alpha}</div>
              <div className="sd-ab">{label.alpha2}</div>

              <div className="sd-digit-group">
                <input
                  className="sd-digit"
                  maxLength={1}
                  inputMode="numeric"
                  value={rows[index].digit1}
                  onFocus={() => setIsKeyboardOpen(true)}
                  ref={(el) => (digit1Refs.current[index] = el)}
                  onChange={(e) => {
                    const val = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 1);
                    setRows((prev) => {
                      const copy = [...prev];
                      copy[index].digit1 = val;
                      return copy;
                    });
                    if (val.length === 1) digit2Refs.current[index]?.focus();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" && rows[index].digit1 === "") {
                      if (index > 0) {
                        digit1Refs.current[index - 1]?.focus();
                      }
                    }
                  }}
                />
                <input
                  className="sd-digit"
                  maxLength={1}
                  inputMode="numeric"
                  value={rows[index].digit2}
                  ref={(el) => (digit2Refs.current[index] = el)}
                  onFocus={() => setIsKeyboardOpen(true)}
                  onChange={(e) => {
                    const val = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 1);
                    setRows((prev) => {
                      const copy = [...prev];
                      copy[index].digit2 = val;
                      return copy;
                    });
                    if (val.length === 1) amountRefs.current[index]?.focus();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" && rows[index].digit2 === "") {
                      digit1Refs.current[index]?.focus();
                    }
                  }}
                />
              </div>
            </div>

            <div className="sd-right">
              <div className="sd-counter">
                <button type="button" onClick={() => decreaseAmount(index)}>
                  -
                </button>
                <input
                  ref={(el) => (amountRefs.current[index] = el)}
                  inputMode="numeric"
                  value={rows[index].amount}
                  onFocus={(e) => {
                    setIsKeyboardOpen(true);
                    e.target.select();
                  }}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    const num = parseInt(val || "0", 10);
                    setRows((prev) => {
                      const copy = [...prev];
                      copy[index].amount = String(Math.min(num, maxQty));
                      return copy;
                    });
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" && rows[index].amount == 0) {
                      digit2Refs.current[index]?.focus();
                    }
                  }}
                />
                <button type="button" onClick={() => increaseAmount(index)}>
                  +
                </button>
              </div>
              <button
                className="sd-add"
                type="button"
                onClick={() => handleAdd(index)}
              >
                ADD
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DoubleDigitScreen;